import isMainDomain from '@helpers/misc/domain/isMainDomain'
import isServerSide from '@helpers/misc/isServerSide'

export default function getDomain() {
  if (isServerSide()) return null // Only client-side
  if (isMainDomain()) return null

  if (localStorage.getItem('salesPointDomain')) {
    return localStorage.getItem('salesPointDomain')
  } else {
    return window.location.hostname
  }
}
